<template>
  <div
    v-if="!data?.item.isArchived"
    :class="`${
      isApiError && (!data.item.id || isApiError.isDelete)
        ? 'tw-border-[red] tw-border-solid tw-border-[1px] tw-rounded-md'
        : ''
    }`"
  >
    <!-- Header -->
    <div
      :class="[
        isApiError && (!data.item.id || isApiError.isDelete)
          ? 'tw-border-none'
          : '',
        'header tw-cursor-pointer tw-pl-[25px] tw-pr-[15px] tw-py-[22px] tw-flex tw-justify-between',
        show && showQuestion ? 'show' : '',
        validation?.$errors[0] && isComplexValidate() ? 'is-invalid-box' : '',
        isApiError && data.item.id && (isApiError.name || isApiError.brandName)
          ? 'border-invalid'
          : '',
      ]"
      style="max-height: 60px"
    >
      <div v-if="isBgText" style="flex: 1">
        <div class="tw-flex name__service">
          <div>
            <span
              style="border-radius: 4px"
              class="tw-text-[11px] tw-text-[#387DFF] tw-font-medium tw-bg-[#E4F1FF] tw-px-[5px] tw-py-[3px] tw-border-[4px]"
              >{{ props.title }}</span
            >
          </div>
          <div style="position: relative; flex: 1">
            <input
              v-model="nameInputRef"
              :class="`enter__name ${validation.$error[0] ? 'is-invalid' : ''}`"
              :placeholder="
                getComponentUiText(
                  'app-menu-submenu-home-setup-wizard-service-input-placeholder-title-1',
                )
              "
              style="border: unset; background-color: unset"
              data-cy="wizard-detail-wrapper-input-name"
              @click.stop
              @blur="onBlurs"
            />
            <span
              v-if="!nameInputRef"
              class="asterisk"
              style="position: absolute; top: -3px; color: red"
              >*
            </span>
          </div>
        </div>
      </div>
      <slot v-if="!isBgText" name="title">
        <span class="tw-text-[14px] tw-text-[#211F58] tw-font-semibold">{{
          props.title
        }}</span>
      </slot>

      <div class="tw-flex tw-gap-[20px] tw-items-center button__more">
        <div
          v-if="isApiError && data.item.id && !isApiError.isDelete"
          class="tw-py-[3px] tw-bg-[#FEE5E2] tw-px-[5px] tw-w-max tw-rounded-[4px] tw-mr-[10px]"
        >
          <p
            class="tw-m-[0px] tw-text-[#F7553C] tw-text-[11px] tw-leading-[130%] tw-font-medium"
          >
            {{ getComponentUiText("app-component-wizards-setup-error-update") }}
          </p>
        </div>
        <div v-if="isShowTagVerified" class="tw-flex tw-gap-[10px]">
          <div
            :class="`${
              isVerified ? 'activeStatus' : 'require'
            } cell-status-domain tw-flex tw-items-center`"
          >
            <span class="tw-text-[12px]">{{
              isVerified
                ? getComponentUiText(
                    "app-component-table-cell-status-dns-verified-1",
                  )
                : getComponentUiText(
                    "app-component-table-cell-status-dns-not-verified-1",
                  )
            }}</span>
          </div>
          <div
            :class="`${
              isVerifiedEmail ? 'activeStatus' : 'require'
            } cell-status-domain tw-flex tw-items-center`"
          >
            <span class="tw-text-[12px]">{{
              isVerifiedEmail
                ? getComponentUiText(
                    "app-component-table-cell-status-email-verified-1",
                  )
                : getComponentUiText(
                    "app-component-table-cell-status-email-not-verified-1",
                  )
            }}</span>
          </div>
        </div>

        <SynchronizaIcon v-if="isPast" class="tw-mr-[10px]" />
        <div class="tw-flex">
          <ButtonShowMore
            :classes="'!tw-py-0 !tw-px-0 !tw-border-0'"
            :id-popover="
              'popover-wizard-detail-wrapper-' +
              pageActive +
              '-' +
              Math.random() * 1000
            "
          >
            <template #default>
              <CustomDropDownItem
                :style="'normal'"
                :id-text="'app-settings-domain-verify-modal-delete-button-1'"
                style-text="!tw-border-none !tw-text-[#f7553c]"
                @click="emitActionModalDelete"
              />
            </template>
          </ButtonShowMore>
          <div
            class="tw-p-[10px] tw-flex tw-items-center tw-justify-start tw-ml-[10px]"
            @click="updateShowAccordion"
          >
            <ArrowIcon :class="['right-arrow-icon', show ? 'show' : '']" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showAccordion"
      :class="`tw-flex name__service error-box ${
        validation?.$errors[0] ? 'tw-mt-[3px]' : ''
      }`"
    >
      <b-form-invalid-feedback :class="{ 'is-invalid': validation?.$error }">
        <VRuntimeTemplate :template="validation?.$errors?.[0]?.$message" />
      </b-form-invalid-feedback>
    </div>
    <span
      v-if="
        validation?.$errors?.[0]?.$message &&
        showValidateNow &&
        isComplexValidate()
      "
      style="color: red"
    >
      <b-form-invalid-feedback :class="{ 'is-invalid': validation?.$error }">
        <VRuntimeTemplate
          :template="validation?.$errors?.[0]?.$message"
        /> </b-form-invalid-feedback
    ></span>
    <!-- Content -->
    <div
      v-if="showQuestion"
      :class="[
        'tw-mt-[3px]',
        'content-container',
        show ? 'show' : '',
        isApiError && (!data.item.id || isApiError.isDelete)
          ? 'tw-border-none'
          : '',
      ]"
    >
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { Ref, ref, watch, onMounted } from "vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import ArrowIcon from "../svgs/arrowIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import VRuntimeTemplate from "vue3-runtime-template";
import SynchronizaIcon from "../svgs/synchronizaIcon.vue";
import { idWizardPage as idPage } from "@/utils/constants";

const emit = defineEmits([
  "update:accordion",
  "update:input:name",
  "update:save:change",
]);
const props = defineProps({
  title: { type: String, default: "", required: false },
  isBgText: { type: Boolean, default: false },
  showAccordion: { type: Boolean, default: false, required: false },
  isVerified: { type: Boolean, default: false, required: false },
  isVerifiedEmail: { type: Boolean, default: false, required: false },
  showQuestion: { type: Boolean, default: true, required: false },
  isShowTagVerified: { type: Boolean, default: false, required: false },
  nameInput: { type: String, default: "", required: false },
  data: { type: Object, default: () => {}, required: false },
  validation: { type: Object, required: false, default: null },
  showValidateNow: { type: Boolean, default: false, required: false },
  isFocus: { type: Boolean, default: false, required: false },
  isPast: { type: Boolean, default: false, required: false },
  isFacingWeb: { type: Boolean, default: false, required: false },
  isApiError: { type: Object, default: null, required: false },
  pageActive: { type: Number, default: 0, required: false },
});
const nameInputRef = ref(props.nameInput);
const show: Ref<boolean> = ref(props.showAccordion);
const isFocus: Ref<boolean> = ref(props.isFocus);
watch(
  () => props.showAccordion,
  () => {
    show.value = props.showAccordion;
  },
);
watch(
  () => props.isFocus,
  () => (isFocus.value = props.isFocus),
);
watch(nameInputRef, () => {
  emit("update:input:name", nameInputRef.value);
});
watch(
  () => props.validation,
  (newValue, oldValue) => {
    if (newValue?.$errors[0]) {
      show.value = true;
    }
  },
  { deep: true },
);

const onValidate = () => {
  props.validation?.$validate();
};
const updateShowAccordion = () => {
  show.value = !show.value;
  emit("update:accordion", show.value);
};

const emitActionModalDelete = () => {
  if (props.isBgText) {
    const data = {
      ...props.data,
      indexGroup: props.data.groupIndex,
      currentIndex: props.data.currentIndex,
    };

    eventEmitter.emit(EmitterEvents.OPEN_WIZARD_DELETE_MODAL, data);
  } else {
    eventEmitter.emit(EmitterEvents.OPEN_WIZARD_DELETE_MODAL, props.data);
  }
};

const isComplexValidate = () => {
  const errors = props.validation?.$errors;
  for (const error of errors) {
    if (error.$validator === "required") {
      return true;
    } else if (!isFocus.value) {
      return true;
    }
  }
  return false;
};
const onBlurs = () => {
  onValidate();
};

onMounted(() => {
  const input = document.querySelector(".enter__name") as HTMLInputElement;
  const asterisks = document.querySelectorAll(".asterisk");

  if (input && asterisks.length) {
    adjustAsteriskPosition();
  }

  // Function declarations
  function adjustAsteriskPosition() {
    const placeholderWidth = getTextWidth(
      getComponentUiText(
        "app-menu-submenu-home-setup-wizard-service-input-placeholder-title-1",
      ),
      getComputedStyle(input).font,
    );
    asterisks.forEach((asterisk) => {
      const ele = asterisk as HTMLElement;
      if (ele) {
        ele.style.left = `${placeholderWidth + 10}px`;
      }
    });
  }

  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = font;
    }
    if (context) {
      return context.measureText(text).width;
    }
    return 0;
  }
});
</script>

<style lang="scss" scoped>
.cell-status-domain {
  width: max-content;
  padding: 3px 5px;
  font-family: Poppins;
  font-size: 11px;
  font-weight: 500;
  line-height: 130%;
  border-radius: 4px;
}

.activeStatus {
  background: var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.require {
  background: var(--ui-orange-soft, #fee5e2);
  color: var(--brand-orange, #f7553c);
}
.header {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
  margin-bottom: 0px;

  &.show {
    margin-bottom: -6px;
  }
}

.content-container {
  padding: 0px;
  height: 0px;
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;

  &.show {
    border: 1px solid #eff0f1;
    border-top: 0px;
    border-radius: 6px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    padding: 31px 25px 25px 25px;
    height: auto;
    overflow: visible;
  }
}

.right-arrow-icon {
  // margin-left: 10px;
  transition: transform 0.3s ease;
  transform: rotate(90deg) scale(1.2);

  &.show {
    transform: rotate(-90deg) scale(1.2);
  }
}
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}

.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  margin-left: 8px;
  color: #211f58;
  width: 95%;
}
::-ms-input-placeholder {
  color: red;
}

@media screen and (min-width: 630px) {
  .header {
    align-items: center;
  }
  .button__more {
    justify-content: center;
  }
}

@media screen and (max-width: 630px) {
  .header {
    flex-direction: column;
    max-height: 100px !important;
  }
  .name__service {
    flex-direction: column;
  }
  .button__more {
    justify-content: flex-end;
  }
  // input {
  //   width: 100% !important;
  // }
  .cell-status-domain {
    width: min-content;
  }
}

.was-validated .enter__name:invalid,
.enter__name.is-invalid {
  border: 1px solid #f7553c;
  background: #fee5e2;

  &::after {
    content: "";
  }
}

.error-box {
  border-right: 1px solid #eff0f1;
  border-left: 1px solid #eff0f1;
  padding-left: 25px;
}

.is-invalid-box {
  border: 1px solid #f7553c;
  background: #fee5e2;
}
.border-invalid {
  border: 1px solid #f7553c;
}
</style>
